import AdminInstance from 'modules/admin/repository';

export const getScriptLogs = (page, size, search, filters) => AdminInstance.getScriptLogs({
  page, size, search, filters,
});
